'use strict';

const Analytics = require('./analytics');

class AnalyticsPromotions extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Analytics Promotions & Info';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();
        this.pushLandingInteraction();
    }

    fillPositions () {
        let container = $('.analytics-promotion');
        let containerImg = $('.analytics-promotion-img');

        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i);
            obj.attr('data-index', i);
        }
        for (let i = 0; i < containerImg.length; i++) {
            let objImg = containerImg.eq(i);
            objImg.attr('data-index', i);
        }
    }

    getPromotionItem (element) {
        let obj = element.data();
        obj.id = this.helper.format4DigitNumber(obj.index);
        let promoName = '';
        if (obj.name) {
            promoName = obj.name.replace(/<[^>]*>?/gm, '').trim();
        }
        obj.name = this.helper.formatString(promoName);
        obj.creative = element.closest('.hero-banner-full--tezenis').length > 0 ? 'slider' : 'boxes';
        return obj;
    }

    getPromotionsList () {
        let items = [];
        let container = $('.analytics-promotion');

        for (let i = 0; i < container.length; i++) {
            if (container.eq(i).closest('.slick-cloned').length) {
                continue;
            }

            let obj = this.getPromotionItem(container.eq(i));
            items.push(obj);
        }

        return items;
    }

    pushLandingInteraction () {
        this.fillPositions();

        let promotions = this.getPromotionsList();
        this.quickImpressionSender.pushPromotionListImpression(promotions);
    }

    pushClickInteraction (element) {
        this.fillPositions();

        let item = this.getPromotionItem(element);
        this.quickImpressionSender.pushPromotionClickImpression(item);
    }

    pushImgClickInteraction (element) {
        this.fillPositions();

        let item = this.getPromotionItem(element);
        item.index = element.parent().find('.analytics-promotion').data('index');
        item.id = this.helper.format4DigitNumber(item.index);
        this.quickImpressionSender.pushPromotionClickImpression(item);
    }

    prepareObservers () {
        var _self = this;

        // Promotion
        $('.analytics-promotion').on('click touchstart', function (e) {
            _self.pushClickInteraction($(this));
        });

        $('.analytics-promotion-img').on('click touchstart', function (e) {
            _self.pushImgClickInteraction($(this));
        });

        // Info
        $('.cm-sovraheader-container a').on('click', function (e) {
            let message = $(e.currentTarget).text().trim();
            _self.quickImpressionSender.pushInfoBannerClickImpression(_self.helper.formatString(message));
        });

        // Customer Service
        $('.analytics-customer-service-link').on('click', function (e) {
            _self.quickImpressionSender.pushCustomerServiceItemClick(_self.helper.formatString($(this).data('name')));
        });

        $('.analytics-customer-service-accordion').on('click', function (e) {
            if ($(e.currentTarget).closest('.accordion-item').hasClass('active')) {
                return;
            }
            let question = _self.helper.formatString($(this).data('name') || '');
            let topic = _self.helper.formatString($('.analytic-customer-service-topic').data('name') || '');
            _self.quickImpressionSender.pushCustomerServiceItemExpand(topic, question);
        });

        // 6.51 TEZENIS STORIES HOME
        $('body').on('click', 'div.experience-assets-storiesSlide', function (e) {
            let name = _self.helper.formatString($(this).find('.story-slide__text').text().trim() || '');
            _self.quickImpressionSender.pushTezenisStoriesItemClick(name);
        });

        // 6.52 TEZENIS STORIES HOME - CLICK ON AN ARROW
        $('body').on('click touchstart', 'div.stories-slider--tezenis .slick-arrow', function (e) {
            _self.quickImpressionSender.pushTezenisStoriesArrowClick();
        });

        $('body').on('click', '.cm-analytics-stories-slide', function (e) {
            let name = _self.helper.formatString($(this).find('.cm-analytics-story-text').text().trim() || '');
            _self.quickImpressionSender.pushTezenisStoriesItemClick(name);
        });

        // 6.53
        $('body').on('click touchstart', '.experience-assets-textPromoFullWidth a', function (e) {
            let text = _self.helper.formatString($(this).parents('.experience-assets-textPromoFullWidth').find('h4').text() || '');
            text += _self.helper.formatString($(this).parents('.experience-assets-textPromoFullWidth').find('p').text() || '');
            _self.quickImpressionSender.pushTezenisCommunicationClick(text);
        });

        // 6.54 PRODUCT CATEGORIES ON THE HOMEPAGE
        $('body').on('click touchstart', '.cm-single-hero-banner-container a', function (e) {
            let text = $(e.currentTarget).closest('.cm-single-hero-banner-container-item-text').find('.cm-richtext :header').text();
            _self.quickImpressionSender.pushTezenisCategoryClick(_self.helper.formatString(text));
        });

        $('body').on('click touchstart', '.cm-category-banner-container-item a', function (e) {
            let text = $(this).closest('.cm-category-banner-container-item').find('.cm-richtext h3').text();
            _self.quickImpressionSender.pushTezenisCategoryClick(_self.helper.formatString(text));
        });

        $('body').on('click touchstart', '.cm-three-category-banner-container-item a', function (e) {
            let text = $(this).closest('.cm-three-category-banner-container-item').find('.cm-richtext h4').text();
            if (!text) {
                text = $(this).closest('.cm-three-category-banner-container-item').find('.cm-cta-button').text();
            }
            _self.quickImpressionSender.pushTezenisCategoryClick(_self.helper.formatString(text));
        });

        $('body').on('click touchstart', '.cm-two-category-banner-container-item a', function (e) {
            let text = $(this).closest('.cm-two-category-banner-container-item').find('.cm-richtext h4').text();
            if (!text) {
                text = $(this).closest('.cm-two-category-banner-container-item').find('.cm-cta-button').text();
            }
            _self.quickImpressionSender.pushTezenisCategoryClick(_self.helper.formatString(text));
        });

        // 7.155 COMPLETE THE PROMO
        $('.analytics-completeThePromo').on('click touchstart', function (e) {
            let promo = $(e.currentTarget).data('promotion-name');
            let location = 'cart';

            if (promo && location) {
                _self.quickImpressionSender.pushCompleteThePromoInteraction(
                    _self.helper.formatString(promo),
                    location
                );
            }
        });
    }
}

const obj = new AnalyticsPromotions();
module.exports = obj;
